import React from "react";

interface Props {
    children: React.ReactNode;
    className?: string;
}

const Pill = ({ children, className = "" }: Props) => (
    <span data-testid="pill" className={`${className} bg-mint-500 py-0.25 px-0.5 rounded type-small-caps text-midnight-500`}>
        {children}
    </span>
);

export default Pill;
